import { render, staticRenderFns } from "./Shortcuts.vue?vue&type=template&id=3d23b6f6&"
import script from "./Shortcuts.vue?vue&type=script&lang=js&"
export * from "./Shortcuts.vue?vue&type=script&lang=js&"
import style0 from "./Shortcuts.vue?vue&type=style&index=0&id=3d23b6f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports